module.exports = __webpack_public_path__ + "static/img/countersign-head.9a92c9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countersign-head.png
// module id = b+Mc
// module chunks = 1